import submitAnswer from '../actions/submitAnswer';

export default [
    submitAnswer,
];



// WEBPACK FOOTER //
// ./src/store/modules/app/signals/submitAnswer.js